import { useEffect, useRef, useState } from "react";

import { Audio } from "../../../components/audio-element";
import { Video } from "../../../components/video-element";
import { useGlobal } from "../../../contexts/globalContext";
import usePreviousValue from "../../../hooks/usePreviousValue";

const ScreenCanvas = () => {
  const {
    SCREEN_STATE,
    SCREEN_STREAM_MAIN_REF,
    SCREEN_STREAM_TEMP_REF,
    SET_AUTO_JOIN,
    MEETING_STATE,

    VIDEO_MAIN_PARENT,
    VIDEO_MAIN,
    VIDEO_TEMP,
    VIDEO_MINI,
    AUDIO_SCREEN_SOUND,
  } = useGlobal();
  const CANVAS_REF = useRef(null);
  const [poolInterval] = useState(2000);

  const [changingResolution, setChangingResolution] = useState(false);

  useEffect(() => {
    if (VIDEO_MAIN.current) {
      VIDEO_MAIN.current.srcObject = SCREEN_STREAM_MAIN_REF.current;
      VIDEO_TEMP.current.srcObject = SCREEN_STREAM_TEMP_REF.current;
      VIDEO_MAIN.current.addEventListener("playing", handlePlayingEvent);
    }
  }, [SCREEN_STREAM_MAIN_REF]);

  const prevScreenId = usePreviousValue(SCREEN_STATE.currentScreen.id);

  useEffect(() => {
    let resizeTimeout;
    if (SCREEN_STATE.currentScreen.state === "playing" && prevScreenId === SCREEN_STATE.currentScreen.id) {
      const mainVideo = VIDEO_MAIN.current;
      const miniVideo = VIDEO_MINI.current;
      const canvas = CANVAS_REF.current;
      const ctx = canvas.getContext("2d");

      const captureFrame = (isChangeInResolution) => {
        canvas.width = mainVideo.videoWidth;
        canvas.height = mainVideo.videoHeight;
        ctx.drawImage(mainVideo, 0, 0);

        if (isChangeInResolution) setChangingResolution(false);
      };

      const handleMiniResize = () => {
        setChangingResolution(true);

        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          captureFrame(true);
        }, 3000);
      };

      if (miniVideo) miniVideo.addEventListener("resize", handleMiniResize);

      const handleFullscreenChange = () => {
        if (!document.fullscreenElement) clearTimeout(resizeTimeout);
      };

      document.addEventListener("fullscreenchange", handleFullscreenChange);

      const storeFrameInterval = setInterval(captureFrame, poolInterval);

      return () => {
        clearInterval(storeFrameInterval);
        if (miniVideo) miniVideo.removeEventListener("resize", handleMiniResize);

        document.removeEventListener("fullscreenchange", handleFullscreenChange);
      };
    }
  }, [changingResolution, SCREEN_STATE.currentScreen.state, SCREEN_STATE.currentScreen.id, poolInterval]);

  const handlePlayingEvent = () => {
    SET_AUTO_JOIN((prev) => ({ ...prev, player: true }));
  };

  return (
    <div ref={VIDEO_MAIN_PARENT} id="canvas-area">
      <Video
        ref={VIDEO_MAIN}
        id="video__screen-main-2"
        className="fn__screen-video"
        style={{
          zIndex: 2,
          visibility: changingResolution ? "hidden" : "visible",
        }}
        autoPlay
      />
      <canvas
        ref={CANVAS_REF}
        style={{
          zIndex: changingResolution ? 3 : 0,
          height: "100vh",
          visibility: changingResolution ? "visible" : "hidden",
        }}
      />
      <Video
        ref={VIDEO_TEMP}
        style={{ opacity: 0, visibility: "hidden", width: 0 }}
        id="video__screen-temp-2"
        className="fn__screen-video"
        autoPlay
      />
      <Video
        ref={VIDEO_MINI}
        id="video__screen-mini"
        className="fn__screen-video"
        style={{
          visibility: changingResolution ? "hidden" : "visible",
        }}
        autoPlay
      />
      {MEETING_STATE.screenAudioStream && (
        <Audio ref={AUDIO_SCREEN_SOUND} id="audio__screen-sound" style={{ zIndex: 1 }} playsInline srcObject={MEETING_STATE.screenAudioStream} />
      )}
    </div>
  );
};
export default ScreenCanvas;
